function isEqual(a: any, b: any): boolean {
  return JSON.stringify(a) === JSON.stringify(b);
}

// Todo - convert this to a named export
// eslint-disable-next-line import/no-default-export
export default isEqual;
